import script from "./Process.vue?vue&type=script&setup=true&lang=js"
export * from "./Process.vue?vue&type=script&setup=true&lang=js"

import "./Process.vue?vue&type=style&index=0&id=7c00ed4c&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c00ed4c"]])

export default __exports__